import * as React from 'react'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import type { AppStateType } from '../reducers/appstate'
import { withRouter } from 'next/router'
import {
  fetchFinePrintPage
} from '../services/contentfulPosts'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import styled from 'styled-components'
import { colors } from '@components/shared'
import HtmlHead from '@components/HtmlHead'

type PropsType = {
  referralGiftPageInfo: any
}

function ReferralGiftTerms (props: PropsType): React.ReactNode {
  return (
    <Wrapper>
      <HtmlHead title={'Dipsea | Referral Gift Terms of Service'}
        />
      <ContentStyled>
        {documentToReactComponents(props.referralGiftPageInfo)}
      </ContentStyled>
    </Wrapper>
  )
}

export async function getStaticProps (): Promise<{ props: PropsType }> {
  const referralGiftPageInfo = await fetchFinePrintPage('referralGiftTerms')

  return {
    props: {
      referralGiftPageInfo
    }
  }
}

const mapStateToProps = (state: AppStateType, ownProps: PropsType): any => {
  return ownProps
}

const mapDispatchToProps = (_dispatch: Dispatch<any>): any => {
  return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReferralGiftTerms) as any) as any

const Wrapper = styled.div<any>`
  background-color: ${colors.midnightBlue};
`

const ContentStyled = styled.div<any>`
  color: #F6F3F0;
  font-family: 'Good Sans Light';
  min-height: 100vh;
  position: relative;
  box-sizing: border-box;
  padding: 100px 20px;
  max-width: 1094px;
  margin: 0 auto;
  div {
    margin: 0 auto;
    max-width: 1000px;
    padding: 60px 20px;
  }
  h1 {
    font-family: 'Queens Condensed Light';
    font-size: 40px;
    line-height: 44px;
    padding: .5em 0 .25em;
    margin: 0px 0 40px;
  }
  h2 {
    font-size: 22px;
    font-weight: bold;
    line-height: 1.5em;
    padding: .5em 0 .25em;
  }
  h3 {
    font-size: 18px;
    font-weight: 800;
    line-height: 22px;
  }
  h4 {
    font-size: 16px;
    font-weight: 800;
    line-height: 20px;
  }
  h5, h6 {
    font-size: 14px;
    font-weight: 800;
    line-height: 1.25em;
  }
  ol, li, ul {
    font-size: 14px;
    line-height: 1.25em;
    list-style-type: circle;
    margin: 0 0 1em;
    padding-inline-start: 20px;
    ol, li, ul {
      list-style-type: circle;
      margin: 0 0 1em;
      padding-inline-start: 10px;
    }
  }
  p {
    font-size: 18px;
    line-height: 1.5em;
    margin: 0 0 1em 0;
  }
  a {
    color: #BF105F;
    font-weight: 700;
    :hover {
      opacity: 0.75;
    }
  }
  strong {
    font-weight: 800;
  }
  animation: fade-in .5s ease-in both;
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`
